<app-entity-tree-header></app-entity-tree-header>

<!-- Common branch section -->
@for (entity of entityTreeData.entitiesOrder.commonBranch | keyvalue: orderByPosition; track entity) {
  <ng-container
  *ngTemplateOutlet="entityTreeBranch; context: {isSpecificBranch: false, entity: getEntityConfiguration(entity.key)}"></ng-container>
}

<!-- Options tabs section -->
<app-entity-tree-tabs (addTabOption)="addBranch($event)"
  (cutTabOption)="cutBranch($event)"
  (selectedOption)="clickSpecificBranchTab($event)"
  [branchesData]="entityTreeData.branchesData"
  [configurationTreeNode]="configurationTreeNode"
  [displayMode]="displayMode"
  [entityTreeData]="entityTreeData"
  [entityTree]="entityTree"
  [hasAddAndCutSpecificBranch]="hasAddAndCutSpecificBranch()"
[options]="entityTree.specificBranchOptions"></app-entity-tree-tabs>

<!-- Specific branch section -->
@if (entityTree.specificBranches != null) {
  <div class="specific-branch-container">
    @for (entity of getSelectedBranchOrderMap() | keyvalue: orderByPosition; track entity) {
      <ng-container
      *ngTemplateOutlet="entityTreeBranch; context: {isSpecificBranch: true, entity: getEntityConfiguration(entity.key)}"></ng-container>
    }
  </div>
}


<!-- Entity tree branch template -->
<ng-template #entityTreeBranch let-entity="entity" let-isSpecificBranch="isSpecificBranch">
  <app-entity-tree-node
    (addToConnectionsClick)="addToConnections($event, entity)"
    (addToPathClick)="addToPath($event, entity)"
    (addToPool)="addToPool($event, entity)"
    (changePoolItemsOrder)="changePoolItemsOrder($event, entity)"
    (editPoolItem)="editPoolItem($event, entity)"
    (removeFromConnectionsClick)="removeFromConnections($event, entity)"
    (removeFromPathClick)="removeFromPath($event, entity)"
    (removeFromPool)="removeFromPool($event,entity)"
    (skipEntityClick)="skipEntityToggle(entity, $event)"
    [configurationTreeNode]="configurationTreeNode"
    [displayMode]="displayMode"
    [enableEntity]="enableEntity(entity)"
    [entityNodeDisplayData]="getEntityDisplayData(entity)"
    [entityNode]="entity"
    [entityPathState]="getTreeNodePathState(entity)"
    [hasClosingConnectionsConnector]="hasClosingConnectionsConnector(entity)"
    [hasEntityConnector]="hasEntityConnector(entity)"
    [hasPathNodeConnector]="hasPathNodeConnector(entity)"
    [hasSingleConnection]="entityHasSingleConnection(entity)"
    [isInOriginalPosition]="treeNodeIsInOriginalPosition(entity)"
    [isSpecificBranch]="isSpecificBranch"
    [openEditEntityModal]="openEditEntityModal"
    [pathConnectorClass]="pathConnectorLengthClass(entity)"

    [pathToConnectionsConnectorClass]="pathToConnectionsConnectorClass(entity)"
  ></app-entity-tree-node>
</ng-template>

